import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yzebjcpvgzgzbqiwostr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl6ZWJqY3B2Z3pnemJxaXdvc3RyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwNDg3OTMsImV4cCI6MjA2ODYyNDc5M30.hU1D4wA8GPnvTQPcPMwfowwq_Y7z1W2wJzhfzVsj7Nw';

if (!supabaseUrl) throw new Error('supabaseUrl is required.');
if (!supabaseAnonKey) throw new Error('supabaseAnonKey is required.');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage, // Explicitly set localStorage for session persistence
  }
});

export const getCurrentUser = () => supabase.auth.getUser()
